<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="cancel()">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{'mealPlanBuilder.selectMenu' | translate}}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-searchbar [(ngModel)]="searchTerm" [placeholder]="'mealPlanBuilder.searchMenus' | translate"></ion-searchbar>

  <ion-list *ngIf="getFilteredMenus().length > 0">
    <ion-item *ngFor="let menu of getFilteredMenus()">
      <div class="meal-plan-icon-circle meal" slot="start">
        <ion-icon name="restaurant-outline"></ion-icon>
      </div>
      <ion-label class="meal-plan-title">{{menu.title}}</ion-label>
      <ion-button (click)="selectMenu(menu)">{{'general.select' | translate}}</ion-button>
    </ion-item>
  </ion-list>

  <p class="ion-padding ion-text-center empty-state" *ngIf="menus.length > 0 && getFilteredMenus().length === 0">
    {{'mealPlanBuilder.noMenusSearch' | translate}}
  </p>
  <p class="ion-padding ion-text-center empty-state" *ngIf="menus.length === 0">
    {{'mealPlanBuilder.noMenusLibrary' | translate}}
  </p>
</ion-content>
